var render = function render(){var _vm=this,_c=_vm._self._c;return _c('brands-table',{attrs:{"headers":_vm.headers,"clients":_vm.clients},on:{"getid":function($event){return _vm.delete_Client($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }